import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _FacebookLogo, _FacebookLogo2, _div, _LoadingOverlay;
import { useEffect, useState } from "react";
import { CREHANA_BASE_URL_PRD } from "@crehana/constants";
import { useTranslation } from "@crehana/i18n";
import FacebookLogo from "@crehana/icons/FacebookLogo";
import GoogleIcon from "@crehana/icons/GoogleIcon";
import { getNextUrl } from "../../utils";
import LoadingOverlay from "../LoadingOverlay";
import { useSocialAuth } from "./hooks";
import SocialButtonsVariantMinimal from "./variants/Minimal";
import SocialButtonsVariantMinimalV2 from "./variants/MinimalV2";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var baseButtonClasses = 'h-56 w-full flex justify-center items-center cursor-pointer text-center bg-white outline-none rounded-5 mb-16';
var SocialButtons = function SocialButtons(_ref) {
  var _span, _span2;
  var _ref$shouldRenderFace = _ref.shouldRenderFacebookButton,
    shouldRenderFacebookButton = _ref$shouldRenderFace === void 0 ? true : _ref$shouldRenderFace,
    referFriendId = _ref.referFriendId,
    _nextUrl = _ref.nextUrl,
    onSuccess = _ref.onSuccess,
    variant = _ref.variant,
    currentForm = _ref.currentForm,
    hideFacebookButton = _ref.hideFacebookButton,
    hideFacebookLink = _ref.hideFacebookLink,
    friendInvitationId = _ref.friendInvitationId,
    _ref$authType = _ref.authType,
    authType = _ref$authType === void 0 ? 'signIn' : _ref$authType,
    labels = _ref.labels;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState('flex'),
    _useState2 = _slicedToArray(_useState, 2),
    showButtonCtaFacebook = _useState2[0],
    setShowButtonCtaFacebook = _useState2[1];
  var _useSocialAuth = useSocialAuth({
      nextUrl: friendInvitationId ? '/premium/' : _nextUrl,
      referFriendId: referFriendId,
      friendInvitationId: friendInvitationId,
      onSuccess: onSuccess,
      hideFacebookLink: hideFacebookLink,
      getNextUrl: friendInvitationId ? undefined : getNextUrl
    }),
    gmailButtonProps = _useSocialAuth.gmailButtonProps,
    facebookButtonProps = _useSocialAuth.facebookButtonProps,
    setupAndInitSocialAuthScripts = _useSocialAuth.setupAndInitSocialAuthScripts,
    _useSocialAuth$authSt = _useSocialAuth.authState,
    processingSocialAuth = _useSocialAuth$authSt.processingSocialAuth,
    loadingFacebookAndGoogleScripts = _useSocialAuth$authSt.loadingFacebookAndGoogleScripts,
    errorToLoadFacebookAndGoogleScripts = _useSocialAuth$authSt.errorToLoadFacebookAndGoogleScripts;

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    setupAndInitSocialAuthScripts();
    var isInstagramWebView = window.navigator.userAgent.toLowerCase().includes('instagram');
    setShowButtonCtaFacebook(isInstagramWebView ? 'none' : 'flex');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var getButtonLabels = function getButtonLabels() {
    var googleLabel;
    var facebookLabel;
    if (authType === 'signUp') {
      var _labels$facebook, _labels$facebook2, _labels$google, _labels$google2;
      facebookLabel = labels !== null && labels !== void 0 && (_labels$facebook = labels.facebook) !== null && _labels$facebook !== void 0 && _labels$facebook.signUp ? labels === null || labels === void 0 ? void 0 : (_labels$facebook2 = labels.facebook) === null || _labels$facebook2 === void 0 ? void 0 : _labels$facebook2.signUp :
      // biome-ignore lint/suspicious/noAssignInExpressions: assignment pattern is intentional
      facebookLabel = t('LOGIN_WITH_FACEBOOK_SING_UP', 'Regístrate con Facebook');
      googleLabel = labels !== null && labels !== void 0 && (_labels$google = labels.google) !== null && _labels$google !== void 0 && _labels$google.signUp ? labels === null || labels === void 0 ? void 0 : (_labels$google2 = labels.google) === null || _labels$google2 === void 0 ? void 0 : _labels$google2.signUp : t('LOGIN_WITH_GOOGLE_SING_UP', 'Regístrate con Google');
    }
    if (authType === 'signIn') {
      var _labels$facebook3, _labels$facebook4, _labels$google3, _labels$google4;
      facebookLabel = labels !== null && labels !== void 0 && (_labels$facebook3 = labels.facebook) !== null && _labels$facebook3 !== void 0 && _labels$facebook3.signIn ? labels === null || labels === void 0 ? void 0 : (_labels$facebook4 = labels.facebook) === null || _labels$facebook4 === void 0 ? void 0 : _labels$facebook4.signIn : t('LOGIN_WITH_FACEBOOK_SIGN_IN', 'Continuar con Facebook');
      googleLabel = labels !== null && labels !== void 0 && (_labels$google3 = labels.google) !== null && _labels$google3 !== void 0 && _labels$google3.signIn ? labels === null || labels === void 0 ? void 0 : (_labels$google4 = labels.google) === null || _labels$google4 === void 0 ? void 0 : _labels$google4.signIn : t('LOGIN_WITH_GOOGLE_SIGN_IN', 'Continuar con Google');
    }
    return {
      facebookLabel: facebookLabel,
      googleLabel: googleLabel
    };
  };
  var _getButtonLabels = getButtonLabels(),
    facebookLabel = _getButtonLabels.facebookLabel,
    googleLabel = _getButtonLabels.googleLabel;
  var renderFacebookButton = function renderFacebookButton() {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (hideFacebookButton && hideFacebookLink) return null;
    if (hideFacebookButton && !hideFacebookLink) {
      var urlToNext = _nextUrl ? "?next=".concat(_nextUrl) : '';
      var next = friendInvitationId ? '?next=/premium/' : urlToNext;
      return /*#__PURE__*/_jsxs("a", {
        href: "".concat(CREHANA_BASE_URL_PRD, "/login/facebook/").concat(next),
        className: "items-center justify-center w-full h-56 px-16 mb-8 sm:px-32 rounded-5",
        style: {
          backgroundColor: '#1877F2',
          display: showButtonCtaFacebook,
          pointerEvents: processingSocialAuth || loadingFacebookAndGoogleScripts || errorToLoadFacebookAndGoogleScripts ? 'none' : 'all'
        },
        children: [_FacebookLogo || (_FacebookLogo = /*#__PURE__*/_jsx(FacebookLogo, {
          color: "white",
          size: 26
        })), ' ', _span || (_span = /*#__PURE__*/_jsx("span", {
          className: "block ml-24 text-white font-link",
          children: facebookLabel
        }))]
      });
    }
    return /*#__PURE__*/_jsxs("button", _objectSpread(_objectSpread({
      type: "button",
      className: "items-center justify-center w-full h-56 px-16 mb-8 sm:px-32 rounded-5",
      style: {
        backgroundColor: '#1877F2',
        display: showButtonCtaFacebook
      }
    }, facebookButtonProps), {}, {
      disabled: processingSocialAuth || loadingFacebookAndGoogleScripts || errorToLoadFacebookAndGoogleScripts,
      children: [_FacebookLogo2 || (_FacebookLogo2 = /*#__PURE__*/_jsx(FacebookLogo, {
        color: "white",
        size: 26
      })), ' ', _span2 || (_span2 = /*#__PURE__*/_jsx("span", {
        className: "block ml-24 text-white font-link",
        children: facebookLabel
      }))]
    }));
  };
  if (variant === 'minimal') {
    return /*#__PURE__*/_jsx(SocialButtonsVariantMinimal, {
      shouldRenderFacebookButton: shouldRenderFacebookButton,
      facebookButtonProps: facebookButtonProps,
      gmailButtonProps: gmailButtonProps,
      processingSocialAuth: processingSocialAuth,
      currentForm: currentForm,
      loadingFacebookAndGoogleScripts: loadingFacebookAndGoogleScripts,
      hideFBAuthButton: hideFacebookButton,
      hideFBAuthLink: hideFacebookLink,
      nextUrl: _nextUrl
    });
  }
  if (variant === 'minimal-2') {
    return /*#__PURE__*/_jsx(SocialButtonsVariantMinimalV2, {
      shouldRenderFacebookButton: shouldRenderFacebookButton,
      facebookButtonProps: facebookButtonProps,
      gmailButtonProps: gmailButtonProps,
      processingSocialAuth: processingSocialAuth,
      currentForm: currentForm,
      loadingFacebookAndGoogleScripts: loadingFacebookAndGoogleScripts,
      hideFBAuthButton: hideFacebookButton,
      hideFBAuthLink: hideFacebookLink,
      nextUrl: _nextUrl
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "relative w-full",
    children: [shouldRenderFacebookButton && renderFacebookButton(), /*#__PURE__*/_jsxs("button", _objectSpread(_objectSpread({
      type: "button",
      className: "".concat(baseButtonClasses),
      style: {
        border: '1px solid rgba(0, 153, 255, 0.3)',
        display: window.navigator.userAgent.toLowerCase().includes('instagram') ? 'none' : 'flex'
      }
    }, gmailButtonProps), {}, {
      children: [_div || (_div = /*#__PURE__*/_jsx("div", {
        className: "mr-4",
        children: /*#__PURE__*/_jsx(GoogleIcon, {
          size: 22
        })
      })), /*#__PURE__*/_jsx("span", {
        className: "tw-font-semibold tw-font-pop",
        children: googleLabel
      })]
    })), (processingSocialAuth || loadingFacebookAndGoogleScripts) && (_LoadingOverlay || (_LoadingOverlay = /*#__PURE__*/_jsx(LoadingOverlay, {})))]
  });
};
export default SocialButtons;